import { Company } from './companyType';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class CompanyApi {

    static async create(company: Company) {
        try {
            const response = await fetch(`${API_BASE_URL}/companies`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ company: company }),
                credentials: 'include', // Include cookies in the request
            });

            //const data: CompanyResponse | ErrorResponse = await response.json();
            // Convert headers to a plain object
            //const headers: { [key: string]: string } = {};
            //response.headers.forEach((value, key) => { headers[key] = value; });
            const responseBody = await response.json();

            if (response.status === 201) {
                return responseBody
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`${responseBody.error} status ${response.status}`);
                }
                else {
                    throw new Error(response.statusText);
                }
            }
            // };
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create company: ${error.message}`);
            } else {
                throw new Error('Failed to create company: An unknown error occurred.');
            }
        }
    }


    static async getCompanyByCode(companyCode: string) {
        try {

            const response = await fetch(`${API_BASE_URL}/companies/by_company_code/${companyCode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });


            const responseBody = await response.json();
            //console.log('=====responseBody======', responseBody.data)

            if (response.status === 200) {
                //console.log('d---d:  ', responseBody.data)

                const company: Company = responseBody.data.attributes;

                return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get compnay: ${error.message}`);
            } else {
                throw new Error('Failed to get company: An unknown error occurred.');
            }
        }
    }


    static async get() {
        try {

            const response = await fetch(`${API_BASE_URL}/companies/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {
                //console.log('d---d:  ', responseBody.data)

                const companies: Company[] = responseBody.data.map((item: any) => {
                    return {
                        company_id: item.attributes.company_id,
                        name: item.attributes.name,
                        company_code: item.attributes.company_code,
                        address_1: item.attributes.address_1,
                        address_2: item.attributes.address_2,
                        city: item.attributes.city,
                        state: item.attributes.state,
                        zip: item.attributes.zip,
                        line_of_business: item.attributes.line_of_business,
                        phone: item.attributes.phone,
                        email: item.attributes.email,
                        web_url: item.attributes.web_url,
                        created_by_account_id: item.attributes.created_by_account_id,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return companies;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get company: ${error.message}`);
            } else {
                throw new Error('Failed to get company: An unknown error occurred.');
            }
        }
    }


    static async update(companyId: string, company: Company) {
        try {
            const response = await fetch(`${API_BASE_URL}/companies/${companyId}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ company: company }),
            });
            const responseBody = await response.json();

            if (response.status === 200) {
                //console.log('d---d:  ', responseBody.data)
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {

                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update company: ${error.message}`);
            } else {
                throw new Error('Failed to update company: An unknown error occurred.');
            }
        }


    }

    static async delete(company_code: number) {
        try {
            const response = await fetch(`${API_BASE_URL}/companies/${company_code}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            if (response.status === 200) {
                return {
                    status: response.status,
                    ok: response.ok,
                };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }


        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete company: ${error.message}`);
            } else {
                throw new Error('Failed to delete company: An unknown error occurred.');
            }
        }
    }

}

export default CompanyApi;